export default class UserModel {
  constructor(data = {}) {
    this.id = data.id || undefined
    this.firstName = data.firstName || ''
    this.lastName = data.lastName || ''
    this.email = data.email || ''
    this.roles = data.roles || []
    this.isLocked = data.isLocked
    this.isManaged = data.isManaged
  }
}
